export const BaseFillCollect = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.361 3.22661C12.2135 2.92953 11.7894 2.93062 11.6435 3.22846L9.19761 8.22086C9.13949 8.33949 9.02655 8.42178 8.89581 8.44074L3.32825 9.24807C3.00037 9.29561 2.86912 9.69834 3.10603 9.92995L7.14122 13.8749C7.23563 13.9672 7.27841 14.1002 7.25555 14.2302L6.29525 19.6916C6.23752 20.02 6.58319 20.2707 6.87738 20.1139L11.8122 17.4831C11.9298 17.4204 12.0709 17.4204 12.1885 17.4831L17.1258 20.1146C17.4198 20.2713 17.7652 20.021 17.708 19.6928L16.7544 14.2297C16.7318 14.1 16.7745 13.9673 16.8686 13.8752L20.8977 9.92927C21.1342 9.69767 21.0031 9.29544 20.6756 9.24768L15.1412 8.44068C15.0113 8.42174 14.8989 8.34028 14.8406 8.2227L12.361 3.22661Z"
      fill="#FFCC00"
      stroke="#FFCC00"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
